<template>
  <div
    class="modal fade"
    v-bind:id="'ModalEditBaseAcc-' + getRowNCode"
    tabindex="99"
    role="dialog"
    aria-hidden="true"
    v-on:mousemove="ModalMove"
    v-on:mouseup="CancelClickModal"
  >
    <div class="modal-dialog modal-notify modal-info" role="document">
      <!--Content-->
      <div class="modal-content text-center" v-bind:style="strModalStyle">
        <!--Header-->
        <div
          class="modal-header d-flex justify-content-between align-items-center"
        >
          <span class="mr-3"></span>
          <p class="heading">ویرایش اطلاعات سرفصل حساب</p>
          <i
            class="fas fa-arrows-alt fa-2x text-white ml-3"
            v-on:mousemove.stop
            v-on:mousedown="MouseClickModal"
            style="cursor: move"
          ></i>
        </div>

        <!--Body-->
        <div class="modal-body px-4 py-2" style="height: 100%; overflow: auto">
          <p class="h6 mt-2 text-info">{{ this.getTitel1 }}</p>

          <div class="row">
            <!-- کادر نوع حساب -->
            <div class="col-12 mb-2 position-relative">
              <select
                id="selectNPerType"
                class="form-control text-center selectStyle"
                v-model="EditTbBaseAcc.NAccType"
                v-bind:disabled="!EnableAccTypeData"
              >
                <!-- v-bind:disabled="EditTbBaseAcc.NCode.toString().length > 3" -->
                <option
                  v-for="option in getNAccTypeData"
                  v-bind:key="option.NCode"
                  v-bind:value="option.NCode"
                >
                  {{ option.SDesc }}
                </option>
              </select>
              <i
                class="
                  fas
                  fa-file-alt fa-1x-half
                  position-absolute
                  iconStyle
                  MandatoryStyle
                "
                title="نوع حساب"
              ></i>
            </div>

            <!-- کادر کد حساب -->
            <div class="col-12 mb-2 position-relative">
              <input
                type="text"
                placeholder="کد حساب"
                class="form-control text-center"
                v-model="EditTbBaseAcc.NCode"
                autocomplete="off"
                style="direction: ltr"
                maxlength="11"
                disabled
              />
              <i
                class="
                  fas
                  fa-qrcode fa-1x-half
                  position-absolute
                  iconStyle
                  MandatoryStyle
                "
                title="کد حساب"
                style="top: 25%"
              ></i>
            </div>

            <!-- کادر شرح حساب -->
            <div class="col-12 mb-2 position-relative">
              <input
                type="text"
                placeholder="شرح حساب"
                class="form-control text-center"
                v-model="EditTbBaseAcc.SDesc"
                autocomplete="off"
                maxlength="80"
                id="inputSDesc"
              />
              <i
                title="شرح حساب"
                class="
                  fas
                  fa-edit fa-1x-half
                  position-absolute
                  iconStyle
                  MandatoryStyle
                "
              ></i>
            </div>

            <template
              v-if="EditTbBaseAcc.NAccType == 1 || EditTbBaseAcc.NAccType == 2"
            >
              <!-- کادر رقم بودجه -->
              <div class="col-12 mb-2 position-relative">
                <input
                  type="text"
                  placeholder="رقم بودجه"
                  class="form-control text-center"
                  v-model="EditTbBaseAcc.NBudget"
                  autocomplete="off"
                  style="direction: ltr"
                  maxlength="10"
                />
                <i
                  class="
                    fas
                    fa-money-bill-wave fa-1x-half
                    position-absolute
                    iconStyle
                  "
                  title="رقم بودجه"
                ></i>
              </div>

              <!-- کادر کد بودجه -->
              <div class="col-12 mb-2 position-relative">
                <input
                  type="text"
                  placeholder="کد بودجه"
                  class="form-control text-center"
                  v-model="EditTbBaseAcc.NBudgetCode"
                  autocomplete="off"
                  style="direction: ltr"
                  maxlength="10"
                />
                <i
                  class="
                    fas
                    fa-money-bill-alt fa-1x-half
                    position-absolute
                    iconStyle
                  "
                  title="کد بودجه"
                ></i>
              </div>

              <!-- کادر نوع مصرف منبع -->
              <div class="col-12 mb-2 position-relative">
                <select
                  id="selectOrg"
                  class="form-control text-center selectStyle"
                  v-model="EditTbBaseAcc.NUseType"
                >
                  <option
                    v-for="option in getNUseType"
                    v-bind:key="option.NUseTypeCode"
                    v-bind:value="option.NUseTypeCode"
                  >
                    {{ option.NUseTypeText }}
                  </option>
                </select>
                <i
                  class="fas fa-plug fa-1x-half position-absolute iconStyle"
                  title="نوع مصرف منبع"
                ></i>
              </div>

              <!-- کادر نوع اعتبار -->
              <div class="col-12 mb-2 position-relative">
                <select
                  id="selectOrg"
                  class="form-control text-center selectStyle"
                  v-model="EditTbBaseAcc.NCreditType"
                >
                  <option
                    v-for="option in getNCreditType"
                    v-bind:key="option.NCreditTypeCode"
                    v-bind:value="option.NCreditTypeCode"
                  >
                    {{ option.NCreditTypeText }}
                  </option>
                </select>
                <i
                  class="
                    far
                    fa-credit-card fa-1x-half
                    position-absolute
                    iconStyle
                  "
                  title="گروه"
                ></i>
              </div>

              <!-- کادر کد ارتباط -->
              <div class="col-12 mb-2 position-relative">
                <input
                  type="text"
                  placeholder="کد ارتباط"
                  class="form-control text-center"
                  v-model="EditTbBaseAcc.NUseState"
                  autocomplete="off"
                  style="direction: ltr"
                  maxlength="10"
                />
                <i
                  class="
                    fas
                    fa-network-wired fa-1x-half
                    position-absolute
                    iconStyle
                  "
                  title="کد ارتباط"
                ></i>
              </div>
            </template>
          </div>
        </div>

        <!--Footer-->
        <div
          class="modal-footer flex-center justify-content-between px-4"
          style="height: 15%"
        >
          <a
            class="btn btn-info waves-effect waves-light"
            v-bind:class="checkConnectToServer ? 'disabled btn-pink' : ''"
            v-on:click="EditBaseAcc()"
          >
            <i
              v-if="checkConnectToServer"
              class="fas fa-sync fa-spin fa-1x ml-2"
            ></i>
            ویرایش اطلاعات سرفصل حساب
          </a>
          <a
            class="btn btn-outline-info waves-effect waves-light"
            v-bind:class="checkConnectToServer ? 'disabled' : ''"
            style="padding-top: 0.375rem; padding-bottom: 0.375rem"
            data-dismiss="modal"
            >انصراف</a
          >
        </div>
      </div>
      <!--/.Content-->
    </div>
  </div>
</template>

<script>
export default {
  name: "EditBaseAcc",
  props: ["Title1", "RowBaseAccData", "EnableAccTypeData"],
  data() {
    return {
      // اطلاعات سرفصل حساب
      EditTbBaseAcc: {
        NYear: 1400, // سال
        NCode: "", // کد حساب
        SDesc: "", // شرح حساب
        NAccType: 0, // نوع حساب
        NBudget: "", // رقم بودجه
        NDebitSum: 0, // جمع بدهکار
        NCreditSum: 0, // جمع بستانکار
        NUserCode: 0, // کد کاربر ثبت کننده
        SDate: "", // تاریخ ثبت
        DTime: "", // ساعت ثبت
        NPerID: 0, // کد پرسنل
        NRemain1: 0, // باقیمانده 1
        NRemain2: 0, // باقیمانده 2
        NRemain3: 0,
        NRemain4: 0,
        NRemain5: 0,
        NRemain6: 0,
        NRemain7: 0,
        NRemain8: 0,
        NRemain9: 0,
        NRemain10: 0,
        NRemain11: 0,
        NRemain12: 0, // باقیمانده 12
        NBudgetCode: "", // کد بودجه
        NCreditType: 0, // نوع نوع اعتبار
        NUseType: 0, // نوع مصرف منبع
        NUseState: "", // کد ارتباط
      },
      isModalHeaderClick: false,
      ModalWidth: 0,
      ModalX: 0,
      strModalStyle: "",
      // کنترل اتصال به سرور
      checkConnectToServer: false,
    };
  },
  mounted() {
    // رویداد نمایش مودال
    // $('#ModalEditBaseAcc-' + this.getRowNCode).on('shown.bs.modal', this.getUserData);
    // رویداد بسته شدن مودال
    $("#ModalEditBaseAcc-" + this.getRowNCode).on(
      "hidden.bs.modal",
      this.HideModal
    );
  },
  computed: {
    // دریافت کد سطر در حال ویرایش
    getRowNCode() {
      this.EditTbBaseAcc.NYear = this.RowBaseAccData.NYear; // سال
      this.EditTbBaseAcc.NCode = this.RowBaseAccData.NCode; // کد حساب
      this.EditTbBaseAcc.SDesc = this.RowBaseAccData.SDesc; // شرح حساب
      this.EditTbBaseAcc.NAccType = this.RowBaseAccData.NAccType; // نوع حساب
      this.EditTbBaseAcc.NBudget = this.RowBaseAccData.NBudget; // رقم بودجه
      this.EditTbBaseAcc.NDebitSum = this.RowBaseAccData.NDebitSum; // جمع بدهکار
      this.EditTbBaseAcc.NCreditSum = this.RowBaseAccData.NCreditSum; // جمع بستانکار
      this.EditTbBaseAcc.NUserCode = this.RowBaseAccData.NUserCode; // کد کاربر ثبت کننده
      this.EditTbBaseAcc.SDate = this.RowBaseAccData.SDate; // تاریخ ثبت
      this.EditTbBaseAcc.DTime = this.RowBaseAccData.DTime; // ساعت ثبت
      this.EditTbBaseAcc.NPerID = this.RowBaseAccData.NPerID; // کد پرسنل
      this.EditTbBaseAcc.NRemain1 = this.RowBaseAccData.NRemain1; // باقیمانده 1
      this.EditTbBaseAcc.NRemain2 = this.RowBaseAccData.NRemain2; // باقیمانده 2
      this.EditTbBaseAcc.NRemain3 = this.RowBaseAccData.NRemain3;
      this.EditTbBaseAcc.NRemain4 = this.RowBaseAccData.NRemain4;
      this.EditTbBaseAcc.NRemain5 = this.RowBaseAccData.NRemain5;
      this.EditTbBaseAcc.NRemain6 = this.RowBaseAccData.NRemain6;
      this.EditTbBaseAcc.NRemain7 = this.RowBaseAccData.NRemain7;
      this.EditTbBaseAcc.NRemain8 = this.RowBaseAccData.NRemain8;
      this.EditTbBaseAcc.NRemain9 = this.RowBaseAccData.NRemain9;
      this.EditTbBaseAcc.NRemain10 = this.RowBaseAccData.NRemain10;
      this.EditTbBaseAcc.NRemain11 = this.RowBaseAccData.NRemain11;
      this.EditTbBaseAcc.NRemain12 = this.RowBaseAccData.NRemain12; // باقیمانده 12
      this.EditTbBaseAcc.NBudgetCode = this.RowBaseAccData.NBudgetCode; // کد بودجه
      this.EditTbBaseAcc.NCreditType = this.RowBaseAccData.NCreditType; // نوع نوع اعتبار
      this.EditTbBaseAcc.NUseType = this.RowBaseAccData.NUseType; // نوع مصرف منبع
      this.EditTbBaseAcc.NUseState = this.RowBaseAccData.NUseState; // کد ارتباط
      return this.EditTbBaseAcc.NCode;
    },
    // دریافت عبارت سربرگ
    getTitel1() {
      setTimeout(() => {
        $("#inputSDesc").focus();
        $("#inputSDesc").select();
      }, 100);
      return this.Title1;
    },
    // دریافت لیست انواع سرفصل حساب
    getNAccTypeData() {
      // دریافت لیست انواع سرفصل حساب
      return this.$store.getters.getNAccTypeData;
    },
    // دریافت لیست منبع مصرف
    getNUseType() {
      // دریافت لیست منبع مصرف
      return this.$store.getters.getNUseType;
    },
    // دریافت لیست نوع اعتبار
    getNCreditType() {
      // دریافت لیست نوع اعتبار
      return this.$store.getters.getNCreditType;
    },
  },
  methods: {
    // رویداد بسته شدن مودال
    HideModal() {
      this.isModalHeaderClick = false;
    },
    CancelClickModal() {
      this.isModalHeaderClick = false;
    },
    // رویداد حرکت مودال
    ModalMove(event) {
      if (this.isModalHeaderClick == true) {
        let strStyle =
          "left:" +
          (event.clientX - this.ModalWidth + this.ModalX) +
          "px; top:" +
          (event.clientY - 50) +
          "px;";
        this.strModalStyle = strStyle;
      }
    },
    // رویداد کلیک بر روی سربرگ مودال
    MouseClickModal(event) {
      this.ModalX = event.target.offsetLeft;
      this.ModalWidth = event.target.parentElement.clientWidth;
      this.isModalHeaderClick = !this.isModalHeaderClick;
    },
    // دریافت اطلاعات سطر مورد نظر از والد
    getRowBaseAccData() {
      this.EditBaseAcc = this.RowBaseAccData;
    },
    // ذخیره تغییرات حساب کاربری
    async EditBaseAcc() {
      // آیا نوع سرفصل حساب مشخص شده است ؟
      // if (this.EditTbBaseAcc.NAccType != 0) {
      // آیا کد حساب مقدار دهی شده است ؟
      if (this.EditTbBaseAcc.NCode != "") {
        // آیا نام حساب ثبت شده است ؟
        if (this.EditTbBaseAcc.SDesc != "") {
          // اعلام اتصال به سرور
          this.checkConnectToServer = true;
          // دریافت توکن احراز هویت
          let token = await this.$store.getters.getUserData.token;
          // // کد کاربری
          // let NUserCode = await this.$store.getters.getUserData
          // .NUserCode;
          // // دریافت تاریخ ثبت
          // this.EditTbBaseAcc.SDate =
          // this.$store.getters.getPersianDateValue.PersianDate;
          // اصلاح دیتا
          if (this.EditTbBaseAcc.NBudget == "") {
            this.EditTbBaseAcc.NBudget = 0;
          }
          if (this.EditTbBaseAcc.NUseState == "") {
            this.EditTbBaseAcc.NUseState = 0;
          }
          // درج ساعت ثبت
          // چون فیلد مورد نظر از نوع
          // DateTime
          //  هست لذا باید فرمت
          // ISO
          // استفاده شود
          // this.EditTbBaseAcc.DTime = new Date().toISOString();
          // درج کد کاربر جاری
          // this.EditTbBaseAcc.NUserCode = NUserCode;
          // ثبت سرفصل حساب جدید در سرور
          await this.$store.dispatch("EditBaseAccDataToServer", {
            EditBaseAcc: this.EditTbBaseAcc,
            token: token,
          });
          // بستن مودال ثبت سرفصل حساب جدید
          $("#ModalEditBaseAcc-" + this.getRowNCode).modal("hide");
          // اعلام اعمال تغییرات به والد
          this.$emit("EditBaseAcc");
        } else {
          // ثبت نام حساب الزامی است
          this.$store.dispatch("notify", {
            notText: "عدم درج نام حساب : درج نام حساب الزامی است !",
            timeOut: 2500,
          });
        }
      } else {
        // ثبت کد حساب الزامی است
        this.$store.dispatch("notify", {
          notText: "عدم درج کد حساب : درج کد حساب الزامی است !",
          timeOut: 2500,
        });
      }
      // اعلام اتمام اتصال به سرور
      this.checkConnectToServer = false;
    },
  },
};
</script>

<style>
/* استایل آیکون کنار فیلدها */
.iconStyle {
  top: 10%;
  right: 0px;
  border-radius: 50%;
  background-color: #e6f2fd;
  border: 1px solid #ced4da;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/* استایل فیلدهای اجباری */
.MandatoryStyle {
  background-color: #fde6e6;
}
/* استایل انتخاب سطر */
.selectStyle {
  font-size: 12px;
  height: 38px;
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/ListBaseAcc/Components/EditBaseAcc.vue